import { Directive, HostListener, Input, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFocusInvalidFieldService } from '../services/forms/form-focus-invalid-field.service';

@Directive({
  selector: '[appFocusInvalidField]',
})
export class FocusInvalidFieldDirective {
  @Input() public appFocusInvalidField!: FormGroup | null | undefined;

  constructor(
    private renderer: Renderer2,
    private focusInvalidFieldsService: FormFocusInvalidFieldService
  ) {}

  @HostListener('click')
  public onClick(): void {
    if (this.appFocusInvalidField) {
      this.focusInvalidFieldsService.setForm(this.appFocusInvalidField, this.renderer).validateFields();
    }
  }
}
